import { createFileRoute } from '@tanstack/react-router';
import { AutomationPageView } from '@/components/marketing/AutomationPage';
import { automationHead } from '@/content/aiAutomation';
export const Route = createFileRoute('/ai-automation/')({head: () => automationHead('overview'), component: OverviewPage});
function OverviewPage() { return <AutomationPageView pageKey="overview" />; }